module.exports = __webpack_public_path__ + "static/cratoni-land-440dc114abea663eff677512cde5eaaf.jpg";